import { render, staticRenderFns } from "./ConnectedGroups.vue?vue&type=template&id=791d2622&scoped=true"
import script from "./ConnectedGroups.vue?vue&type=script&lang=js"
export * from "./ConnectedGroups.vue?vue&type=script&lang=js"
import style0 from "./ConnectedGroups.vue?vue&type=style&index=0&id=791d2622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d2622",
  null
  
)

export default component.exports